module.exports = __webpack_public_path__ + "static/media/create-work.4694ed5d.PNG";